import { formatDistanceStrict } from 'date-fns'

const shortDistanceLocale = {
  formatDistance: (token: string, count: number) => {
    const units: Record<string, string> = {
      xSeconds: `${count}s`,
      xMinutes: `${count}m`,
      xHours: `${count}h`,
      xDays: `${count}d`,
      xMonths: `${count}mo`,
      xYears: `${count}y`,
    }
    return units[token] || `${count}`
  },
}

export function formatTimeAgo(date: Date | string | number): string {
  const parsedDate = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date
  return `${formatDistanceStrict(parsedDate, new Date(), { locale: shortDistanceLocale })} ago`
}

